import React from 'react'
import { app, auth, firestore, storage } from "../../firebase";
import {
  getFirestore,
  collection,
  addDoc,
  doc,
  updateDoc,
  serverTimestamp
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getAuth } from "firebase/auth";

const Table = ({currentRows,handleEdit,handleDelete ,theme , showModal , setShowModal}) => {

  
  const sortByDate = (data) => {
    return data.sort((a, b) => {
      // Asumăm că 'createdAt' este de tip timestamp în format milisecunde
  
      // Convertim 'createdAt' la număr pentru a putea sorta
      const timestampA = a.createdAt;
      const timestampB = b.createdAt;
  
      // Sortare în ordine descrescătoare (cele mai noi mai întâi)
      return timestampB - timestampA;
    });
  };
  // Sortați datele înainte de a le afișa în tabel
  const sortedCurrentRows = sortByDate(currentRows);

  const handleDuplicate = async (values) => {
    try {
      const newDocument = { ...values };
      delete newDocument.id; // Elimină ID-ul vechi
  
      const docRef = await addDoc(collection(firestore, "post"), newDocument); // Creează un nou document
  
      alert(`Document duplicat cu succes! ID nou: ${docRef.id}`);
  
      window.location.reload(); // Reîncarcă pagina
    } catch (error) {
      console.error("Eroare la duplicare:", error);
      alert("Eroare la duplicare.");
    }
  };
  

  
  return (
    <>  
     { showModal && (
      <div className='modalLoading'>
        <div className="spinner-border  text-light" >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
        )}
        <div className='table-responsive small'>
    <table className={`table table-sm  ${theme === "dark" ? "table-dark" : ""}`}>
      <thead>
        <tr className='text-center'>
          <th scope="col" className='col-1'>IMG</th>
          <th scope="col" className='col-1'>Titlu</th>
          <th scope="col" className='col-1 d-none d-md-table-cell'>SKU</th>
          <th scope="col" className='col-1 d-none d-md-table-cell'>STOC</th>
          <th scope="col" className=' col-1 d-none d-md-table-cell'>Preț</th>
          <th scope="col" className=' col-1 d-none d-md-table-cell'>Preț redus</th>
          <th scope="col" className='col-1'>Editare</th>
          {/* <th scope="col" className='col-1'>Duplicare</th> */}
          <th scope="col" className='col-1'>Stergere</th>
        </tr>
      </thead>
      <tbody>
      {sortedCurrentRows.map((values, index) => (
          <tr key={index} className="align-middle text-center" >
            <td> {values.mainImage && Object.keys(values.mainImage).map((key) => (
              <img
                key={key}
                src={values.mainImage[key]}
                alt={values.title}
                style={{ width: "40px", height: "40px", objectFit: "cover" }}
              />
            ))}</td>
            <td className="align-middle ">{values.titlu}</td>
            <td className="align-middle d-none d-md-table-cell">{values.sku}</td>
            <td className="align-middle d-none d-md-table-cell"> {values.comanda ? "În stoc" : "Indisponibil"}</td>
            <td className="align-middle d-none d-md-table-cell">{values.pret.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</td>
            <td className="align-middle d-none d-md-table-cell">{values.pretNou.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</td>
          
           
            <td>
              <button className="btn btn-primary btn-sm"
                data-bs-toggle="modal"
                data-bs-target="#editModal"
                onClick={() => handleEdit(values)}>
                <i className="fa-regular fa-pen-to-square"></i>
              </button>
            </td>
            {/* <td>
  <button className="btn btn-success btn-sm"
    onClick={() => handleDuplicate(values)}>
    <i className="fa-solid fa-copy"></i> 
  </button>
</td> */}
            <td>

              
              <button className="btn btn-primary btn-sm"
                onClick={() => handleDelete(values.id)}>
                <i className="fa-solid fa-trash"></i>
              </button>
            </td>
         

          </tr>
        ))}
      </tbody>
    </table>
  </div>
  </>

  )
}

export default Table
